(function report($, Drupal) {
  Drupal.behaviors.report = {
    attach(context) {
      if (window.location.href.indexOf('report') > -1) {
        const tocLink = $('.interactive-map__key-link', context);
        const regionLink = $('.interactive-map__region', context);

        const showRegionContacts = (id) => {
          const sidebar = document.getElementsByClassName('report__sidebar');
          const content = document.getElementsByClassName('report__content');
          const sidebarClass = `.report__sidebar--${id}`;
          const contentClass = `.report__content--${id}`;
          const target = $(contentClass);

          // Loop over all the TOC and Blocks on the page and remove active classes.
          for (let i = 0; i < content.length; i++) {
            $(content[i]).removeClass('report__content--active');
          }

          for (let i = 0; i < sidebar.length; i++) {
            $(sidebar[i]).removeClass('report__sidebar--active');
          }

          // Display Content
          $(sidebarClass).addClass('report__sidebar--active');
          $(contentClass).addClass('report__content--active');

          // Smooth Scroll to Content on Click
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top,
            }, 1000);
          }

          return false;
        };

        tocLink.click((e) => {
          e.preventDefault();
          $(e.target).blur();

          const blockID = $(e.target).attr('href').replace('#', '');
          showRegionContacts(blockID);
        });

        regionLink.click((e) => {
          e.preventDefault();
          $(e.target).blur();

          const blockID = $(e.target.parentElement).attr('href').replace('#', '');
          showRegionContacts(blockID);
        });

        // Check window hash and scrolls to requested content.
        const pageHash = window.location.hash;
        showRegionContacts(pageHash.replace('#', ''));
      }
    },
  };
}(jQuery, Drupal));
